import { initializeBugsnag, userAgentParser } from '@soluto-home-web/platform-utils';
initializeBugsnag();

import { enhanceStaticData, bindToIdentityChanges } from './enhance-bugsnag-errors';
import { initAnalytics } from '../services/analyticsInitializer';
import { initLogger, logger } from '@soluto-home-web/platform-utils';
import rxjsconfig from 'recompose/rxjsObservableConfig';
import { setObservableConfig } from 'recompose';
import OriginIdentifier from '../services/originIdentifier';
import { initTweek } from '../services/tweekInitializer';
import { UserBrowser, identity } from '@soluto-home-web/platform-core';
import { SolutoMonitorWriter, setMonitorWriters } from '@soluto-home-web/platform-utils';

enhanceStaticData();
bindToIdentityChanges();

initLogger({
  Partner: globals.REACT_APP_PARTNER,
  IsTest: globals.REACT_APP_IS_TEST,
  IsLocalNumber: globals.REACT_APP_IS_LOCAL_NUMBER,
  HostName: location.hostname,
  Environment: globals.NODE_ENV,
  UserBrowserId: UserBrowser.Id,
  Browser: userAgentParser.getBrowserName(),
  OS: userAgentParser.getOs(),
  OSVersion: userAgentParser.getOsVersion(),
});

identity.updated$.subscribe((user) => {
  !!user.id &&
    logger.updateContext((currentContext) => ({
      ...currentContext,
      HomeUserId: user.id,
    }));
});

identity.loggedOut$.subscribe(() => {
  logger.updateContext((currentContext) => {
    delete currentContext['HomeUserId'];
    return currentContext;
  });
});

setObservableConfig(rxjsconfig);
OriginIdentifier.initialize(window.document.referrer);

initTweek();
initAnalytics();

setMonitorWriters([new SolutoMonitorWriter('https://prodhome1loggingapi.mysoluto.com')]);



// WEBPACK FOOTER //
// ./packages/web-app/src/initializations/dependencies.ts